export const BI_BASE_API_URL = process.env.REACT_APP_BI_BASE_API_URL_UNAUTHORIZED;

// GET - Obtém token a partir de uma chave serial
export const BI_POST_AUTHENTICATION_BY_SERIAL_NUMBER_ENDPOINT = '/authentication/serial-number';

// GET - Valida um token
export const BI_GET_AUTHENTICATION_BY_TOKEN_ENDPOINT = '/authentication/token/validate-token';

export const BI_AUTH_NECESSARY_ROLES = ['ICU International Benchmarking', 'SuperAdministrator', 'Administrator'];
